// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table_tableWrapper__IfFrK","selectContainer":"Table_selectContainer__D1yRh","select":"Table_select__VaNgB"};